/**
 * Get object property by path.
 *
 * @static
 * @param {Object} obj - target
 * @param {string[]} path - path
 * @return {Object} return property
 * @example
 * const obj = {
 *   key: ['value']
 * }
 *
 * getProp(obj, ['key', 0]) // value
 */
function getProp(obj, path) {
    let temp = obj;
    for (let i = 0; i < path.length; ++i) {
        temp = temp[path[i]];
    }
    return temp;
}

/**
 * Set object property by path.
 *
 * @static
 * @param {Object} obj - target
 * @param {string[]} path - path
 * @param {Object} value - value
 * @return {boolean} return true
 * @example
 * const obj = {
 *   key: ['value']
 * }
 *
 * setProp(obj, ['key', 0], 'new-value') // true
 * obj.key // ['new-value']
 */
function setProp(obj, path, value) {
    if (path.length === 0)
        throw new Error('Cannot assign target object itself');
    let temp = obj;
    for (let i = 0; i < path.length; ++i) {
        if (i === path.length - 1) {
            temp[path[i]] = value;
        }
        else {
            temp = temp[path[i]];
        }
    }
    return true;
}

/**
 * Remove object property by path.
 *
 * @static
 * @param {Object} obj - target
 * @param {string[]} path - path
 * @return {boolean} return true
 * @example
 * const obj = {
 *   key: ['value']
 * }
 * removeProp(obj, ['key', 0]) //true
 * obj.key // []
 */
function removeProp(obj, path) {
    if (path.length === 0)
        throw new Error('Cannot remove target object itself');
    let temp = obj;
    for (let i = 0; i < path.length; ++i) {
        if (i === path.length - 1) {
            delete temp[path[i]];
        }
        else {
            temp = temp[path[i]];
        }
    }
    return true;
}

export { getProp, removeProp, setProp };
//# sourceMappingURL=index.mjs.map
